import React from 'react';

import Header from '.././Elements/Header';
import Banner from '.././Elements/Banner';
import GraphView from '.././Elements/GraphView';
import BodyClassSetter from '../Elements/BodyClassSetter';
import FilterPanelFormWrapper from "../Elements/FilterPanelFormWrapper";
import Footer from "../Elements/Footer";
import data from '.././dataModel';
import { selectAllClubs, getGraphById, getPrevNextGraphName, getGraphByUrl, sortById  } from "../Utils";

import { useViewStore, useClubStore } from '../store.js';

class DetailView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOverview: true,
            selectedClubs: useClubStore.getState().selectedClubs,
            currentGraph: { name: "", index: "" },
            filterCount: 0,
            filterState: [],
            showKeys: true,
            nextGraph: null,
            prevGraph: null,
            urlParams: null,
            graphNav: null
        }

        this.data = data;
        this.state.urlParams = this.getGraphClubFromUrl();
        this.state.currentGraph = this.getGraphData();
        this.state.nextGraph = getPrevNextGraphName(this.state.currentGraph[0].id, 1);
        this.state.prevGraph = getPrevNextGraphName(this.state.currentGraph[0].id, 0);
    }

    componentDidMount() {
        useViewStore.setState({currentView: 'OverviewView' });
    }

    componentDidUpdate(prevProps, prevState) {
        const newUrlParams = this.getGraphClubFromUrl();
        if (newUrlParams.graph !== prevState.urlParams.graph || newUrlParams.club !== prevState.urlParams.club) {
            this.setState({
                urlParams: newUrlParams,
                currentGraph: this.getGraphData(newUrlParams)
            });
        }
    }

    getGraphView(selectedClubs, graphName) {
        return (<GraphView selectedClubs={selectedClubs} graphName={graphName} />)
    }

    getFilterData = (filterData) => {
        const selectedClubs = this.setShouldShowKey(filterData.clubs.filter((clubs) => (clubs.checked === true)));

        if (selectedClubs[0].name.indexOf("Overview") === 0 && selectedClubs[0].checked) {
            this.setState({
                selectedClubs: selectAllClubs(),
                isOverview: filterData.isOverview,
                filterState: filterData
            });
        } else {
            this.setState({
                selectedClubs,
                isOverview: filterData.isOverview,
                filterState: filterData
            });
        }
    }

    setShouldShowKey(filter) {
        sortById(filter, "addedOrder").forEach(item => (
            item.shouldShowKey = false
        ));
        filter[0].shouldShowKey = true;
        return filter;
    }

    isOverview() {
        return this.state.isOverview;
    }

    getClassBasedByState() {
        var className = "DetailsView";
        if (this.state.isOverview) {
            className = "OverviewView";
        }
        return className;
    }

    getGraphClubFromUrl() {
        var urlParams = new URLSearchParams(window.location.search);
        return {
            graph: urlParams.get('graph'),
            club: urlParams.get('clubname')
        }
    }

    getGraphData() {
        var graphData = getGraphByUrl(this.state.urlParams.graph);
        if (graphData.length === 0) {
            graphData = getGraphById(0);
        }
        return graphData;
    }

    render() {
        const { selectedClubs, currentGraph, graphNav } = this.state;
        var nextGraph = this.state.nextGraph;
        var prevGraph = this.state.prevGraph;
        const { isOverview } = this.state;

        var selectedColour = typeof this.state.filterState.colourToUse != "undefined" ? this.state.filterState.colourToUse : "";

        return (
            <BodyClassSetter>   
                <Header title="P&I Market Review 2024"/>
                <Banner />
        
                <main>
                    <div className="mainView-wrapper">
                        <GraphView
                            selectedClubs={selectedClubs}
                            selectedClubsLength={selectedClubs.length}
                            currentGraph={currentGraph}
                            isOverview={this.state.isOverview}
                            showKeys={this.state.showKeys}
                            graphNav={graphNav}
                        />
                    </div>
                    <FilterPanelFormWrapper
                        clubs={data.clubs}
                        filterGetter={this.getFilterData}
                        currentGraph={currentGraph}
                        nextGraph={nextGraph}
                        prevGraph={prevGraph}
                    />
                </main>
                <Footer />
            </BodyClassSetter>
        )
    }

}

export default DetailView;
